<template>
    <div>
        
        <Table v-if="newTableList.length>0 && (labelStatus==3||labelStatus==2)" :columns="columns"
                :data="newTableList"
                size="small"
                ref="tabledoc"
                border>
        </Table>
        <div v-if="newTableList.length==0 && labelStatus==2" class="margin-15 text-center">面单购买中，请稍后查看...</div>
        <div v-if="labelStatus==1" class="margin-15 text-center">暂无数据...</div>
    </div>
</template>

<script>
    export default {
        props:['tableList','labelStatus'],
        data(){
            return {
                newTableList:[],
            }
        },
        created(){
            this.newTableList = this.labelStatus == 1 ? []:this.tableList
        },
        computed:{
            columns(){
                return [
                    {
                        title:'No',
                        type:'index',
                        width:65,
                    },
                    {
                        title: "Tracking No",
                        key: "trackNo",
                        render:(h,{row})=>{
                            return <div>
                                <a class="color-primary" onClick={this.handleClick.bind(this, row.packageUrl)}>{row.trackNo}</a>
                            </div>
                        }
                    },
                    {
                        title: "Carrier Service",
                        key: "serviceCode",
                    },
                    {
                        title: "ERPSKU",
                        key: "erpSku",
                    },
                    {
                        title: "长宽高(inch)",
                        render:(h,{row})=>{
                            return <div>
                                {this.handleUnit(
                                    row.packageLength,
                                    "cm",
                                    "inch"
                                )||'--'}
                                *
                                {this.handleUnit(
                                    row.packageWidth,
                                    "cm",
                                    "inch"
                                )||'--'}
                                *
                                {this.handleUnit(
                                    row.packageHeight,
                                    "cm",
                                    "inch"
                                )||'--'}
                            </div>
                        }
                    },
                    {
                        title: "重量(lbs)",
                        key: "packageWeight",
                        render: (h, { row }) => {
                            return (
                                <div>
                                    {this.handleUnit(row.packageWeight, "g", "lb")}
                                </div>
                            );
                        },
                    },
                    {
                        title: "物流状态",
                        key: "trackStatus",
                        render:(h,{row})=>{
                            let name = '';
                            switch(row.trackStatus){
                                case 0 : name = 'unkown';break;
                                case 1 : name = 'pre_transit';break;
                                case 2 : name = 'in_transit';break;
                                case 3 : name = 'out_for_delivery';break;
                                case 4 : name = 'delivered';break;
                                case 5 : name = 'available_for_pickup';break;
                                case 6 : name = 'return_to_sender';break;
                                case 7 : name = 'failure';break;
                                case 8 : name = 'cancelled';break;
                                case 9 : name = 'error';break;
                            }
                            return <div>
                                {name}
                            </div>
                        }
                    },
                ]
            }
        },
        methods:{
            handleClick(url){
                console.log(44457678889)
                window.open(url, '_blank');
            }
        }
    }
</script>